import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChipsComponent } from './chips.component';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PipeModule } from '@app/system/pipes/pipe.module';

@NgModule({
	declarations: [ChipsComponent],
	exports: [ChipsComponent],
	imports: [
		CommonModule,
		MatChipsModule,
		MatIconModule,
		MatTooltipModule,
		FlexLayoutModule,
		PipeModule
	]
})
export class ChipsModule { }
